var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"my-0 py-0",attrs:{"cols":"12"}},[_c('div',{staticClass:"mx-0 mb-2"},[_c('div',{staticClass:"ml-n4 mr-n8 mx-md-n6",class:_vm.color},[_c('v-card',{staticClass:"transparent px-4 px-md-6 py-2",attrs:{"width":"100%","flat":"","tile":""}},[_vm._t("default")],2)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }